export const ORBIT_BUNDLE_SESSION_KEY = 'currentClaim';
export const ORBIT_BUNDLE = 'currentBundleValue';
export const CURRENT_FLOW_STATE = 'currentFlowState';
export const PLAN_NUMBER = 'planNumber';
